import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const DeleteIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#CB0B0B";
  if (color) c = color;
  return (
    <SvgIcon
      style={{ transform: `scale(${scale || 1})`, fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.474.842h5.052c.465 0 .842.377.842.842v.842H4.631v-.842c0-.465.378-.842.843-.842ZM3.789 2.526v-.842A1.685 1.685 0 0 1 5.474 0h5.052c.93 0 1.684.754 1.684 1.684v.842h2.527a.421.421 0 1 1 0 .842H1.263a.421.421 0 1 1 0-.842H3.79Zm1.685 11.369a.421.421 0 0 1-.422-.421V7.158a.421.421 0 0 1 .843 0v6.316a.421.421 0 0 1-.421.42Zm2.526 0a.421.421 0 0 1-.421-.421V7.158a.421.421 0 0 1 .842 0v6.316a.421.421 0 0 1-.421.42Zm2.526 0a.421.421 0 0 1-.42-.421V7.158a.421.421 0 0 1 .841 0v6.316a.421.421 0 0 1-.42.42Z"
        fill={c}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.526 15.158V5.053a.421.421 0 1 1 .842 0v9.263c0 .465.378.842.843.842h7.579a.842.842 0 0 0 .842-.842V5.053a.421.421 0 1 1 .842 0v10.105a.842.842 0 0 1-.842.842H3.368a.842.842 0 0 1-.842-.842Z"
        fill={c}
      />
    </SvgIcon>
  );
};

export default DeleteIcon;
